import React, { Component } from 'react'
import NavigatorMain from '../NavigatorMain';
import {
    hashHistory
} from 'react-router';

export default class FeiL extends Component {
    goBack(){
        hashHistory.goBack();
    }
  render() {
    return (
      <div>
        <NavigatorMain>
        <div className="headerblacks">
                <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
                <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",fontWeight:"bold"}}>费率详情</div>
                <div style={{width:"44px"}}></div>
            </div>
        </NavigatorMain>
        <div style={{paddingTop:"44px",paddingLeft:"0.2rem",paddingRight:"0.2rem"}}>
          <div style={{paddingTop:"0.6rem"}}>
            <div style={{display:"flex",alignItems:"center"}}>
              <div style={{width:"16px",height:"16px",borderRadius:"16px",display:"flex",justifyContent:"center",alignItems:"center",color:"#fff",background:"#CE9968"}}>1</div>
              <div style={{fontSize:"0.28rem",color:"#333333",marginLeft:"5px"}}>申购费与赎回费</div>
            </div>
            <div style={{display:"flex",alignItems:"center",marginTop:"5px"}}>
              <div style={{width:"0.7rem"}}></div>
              <div style={{fontSize:"0.24rem",color:"#999999"}}>本组合不重复收取申购费用、赎回费用。成分基金申购费用0至1折，成分基金赎回费用按照基金招募说明书收取。</div>
            </div>
            <div style={{display:"flex",alignItems:"center",marginTop:"0.3rem"}}>
              <div style={{width:"16px",height:"16px",borderRadius:"16px",display:"flex",justifyContent:"center",alignItems:"center",color:"#fff",background:"#CE9968"}}>2</div>
              <div style={{fontSize:"0.28rem",color:"#333333",marginLeft:"5px"}}>投资顾问服务费</div>
            </div>
            <div style={{display:"flex",alignItems:"center",marginTop:"5px"}}>
              <div style={{width:"0.7rem"}}></div>
              <div style={{fontSize:"0.24rem",color:"#999999"}}>本组合以客户账户资产净值{this.props.location.state.manageFeeRate!=null?this.props.location.state.manageFeeRate:""}（年化）计提投资顾问服务费。每日计提，月度结算。</div>
            </div>
          </div>
        </div>
      
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/FeiL.js